var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { b as addGlobalMiddleWare } from "../../RestServiceBase-1fb330a3.js";
import logger from "./Logger.js";
class RestLogger {
  getMiddleware() {
    return (s, n) => this.applySettings(s, n);
  }
  applySettings(settings, next) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      const result = yield next(settings);
      if (!result.isSuccessful()) {
        logger.log("ApiError - " + ((_a = result == null ? void 0 : result.errorContext) == null ? void 0 : _a.displayError), __spreadProps(__spreadValues({
          name: "ApiError"
        }, result.errorContext), {
          requestUrl: settings.url,
          requestMethod: settings.method,
          requestBody: settings.data,
          responseCode: (_b = result == null ? void 0 : result.completeResponse) == null ? void 0 : _b.status,
          responseBody: (_c = result == null ? void 0 : result.completeResponse) == null ? void 0 : _c.responseJSON,
          serverRequestId: (_e = (_d = result == null ? void 0 : result.completeResponse) == null ? void 0 : _d.getResponseHeader("requestid")) != null ? _e : "Failed to get requestid from API response header",
          statusCode: (_g = (_f = result == null ? void 0 : result.completeResponse) == null ? void 0 : _f.status) != null ? _g : 0,
          statusText: result.statusText,
          // @ts-ignore
          readyState: (_i = (_h = result.completeResponse) == null ? void 0 : _h.readyState) != null ? _i : "unknown"
        }));
      }
      return result;
    });
  }
}
function applyRestLoggerMiddleware() {
  addGlobalMiddleWare(new RestLogger().getMiddleware());
}
export {
  RestLogger,
  applyRestLoggerMiddleware
};
//# sourceMappingURL=RestLogger.js.map
